<template>
  <div class="loading">
    <van-loading
      :size="$pxtorem(32)"
      color="#1989fa"
    />
    <div class="text">
      {{ title }}
    </div>

    <ul
      v-if="inject"
      style="position: fixed; visibility: hidden;"
    >
      <li>小哈换电，永不断电</li>
      <li>电瓶车换电</li>
      <li>新能源</li>
      <li>两轮换电</li>
      <li>换电</li>
      <li>哈啰换电</li>
      <li>哈啰出行换点</li>
      <li>电池</li>
    </ul>
  </div>
</template>

<script>
import { mapVant } from '@/utils';
import { Loading } from 'vant';

export default {
  components: {
    ...mapVant(
      Loading,
    ),
  },
  props: {
    title: {
      type: String,
      default: '加载中...',
    },
  },
  data() {
    return {
      inject: window.__PRERENDER_INJECTED,
    };
  },
};
</script>

<style lang="less" scoped>
.loading {
  line-height: 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
  height: 400px;
  font-weight: 400;
  color: #333;

  .text {
    padding-left: 10px;
    font-size: 17px;
    margin-top: 12px;
    font-weight: 400;
  }
}
</style>
